import { DELETE_VORLAGE_ABSCHNITT } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteVorlageAbschnitt/mutation';
import {
  Mitarbeiter_DeleteVorlageAbschnittMutation,
  Mitarbeiter_DeleteVorlageAbschnittMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useDeleteVorlageAbschnitt() {
  const [execute, result] = useMutation<
    Mitarbeiter_DeleteVorlageAbschnittMutation,
    Mitarbeiter_DeleteVorlageAbschnittMutationVariables
  >(DELETE_VORLAGE_ABSCHNITT, {
    refetchQueries: [
      'mitarbeiter_rotationsplanVorlagen',
      'mitarbeiter_rotationsplanVorlageById',
    ],
    awaitRefetchQueries: true,
  });

  const deleteVorlageAbschnitt = useCallback(
    (variables: Mitarbeiter_DeleteVorlageAbschnittMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [deleteVorlageAbschnitt, result] as const;
}
